var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrap"},[_c('AppContentHeader',{attrs:{"headline":"User management"}}),_c('UserInvitation',{on:{"getUsers":function($event){return _vm.getUsers()}}}),_c('UsersList',{ref:"userList"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }